import React from 'react'

import { Square } from 'components/common/genericStyles'

import * as Styles from './styles'

export default function ClassParticipantsContainer({
    students,
    isTeacherMinimized,
    teacher,
    setIsTeacherMinimized,
    isArtefact,
}) {
    return (
        <Styles.Wrapper>
            {isTeacherMinimized && isArtefact && (
                <Styles.TeacherParticipantView
                    onClick={() => {
                        isTeacherMinimized && setIsTeacherMinimized(false)
                    }}
                >
                    {teacher}
                </Styles.TeacherParticipantView>
            )}
            {!isTeacherMinimized && isArtefact && (
                <Styles.ArtefactMinimized
                    onClick={() => {
                        !isTeacherMinimized && setIsTeacherMinimized(true)
                    }}
                />
            )}
            {students.map(student => (
                <Square.Area key={student.key}>
                    <Square.Wrapper>{student}</Square.Wrapper>
                </Square.Area>
            ))}
        </Styles.Wrapper>
    )
}
